"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.t = exports.setStore = exports.mergeTranslations = exports.getLocale = exports["default"] = exports.changeLocale = exports.T = exports.L = exports.Hyphenated = void 0;
exports.translateComponent = translateComponent;
exports.translations = exports.translationExists = void 0;
exports.use = use;
exports.useTranslationWithoutStore = useTranslationWithoutStore;
var _reactReduxI18n = require("react-redux-i18n");
var _react = _interopRequireWildcard(require("react"));
var _server = _interopRequireDefault(require("react-dom/server"));
var _reactRedux = require("react-redux");
var _get = _interopRequireDefault(require("lodash/get"));
var _isObject = _interopRequireDefault(require("lodash/isObject"));
var _isString = _interopRequireDefault(require("lodash/isString"));
var _merge = _interopRequireDefault(require("lodash/merge"));
var _reactHyphen = _interopRequireDefault(require("react-hyphen"));
var _configuration = require("../App/configuration");
var _excluded = ["escapeDot"],
  _excluded2 = ["escapeDot"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * The Redux Store object
 * @type Store
 */
var store;

/**
 * The setup method
 *  - sets the store object used for redux
 *  - sets the locale
 *  - adds the pre-init translations map
 * @param {Store} reduxStore
 */
var setStore = exports.setStore = function setStore(reduxStore, initialCode) {
  if (!reduxStore.getState || !reduxStore.dispatch) {
    throw new Error('A valid redux store must be given!');
  }
  store = reduxStore;
  if (store && initialCode) {
    // set the locale from the configuration
    changeLocale(initialCode);
  }

  // Adds the pre-init translations
  mergeTranslations(translations);
};

/**
 * Global translations object (pre-setup)
 * @type {{}}
 */
var translations = exports.translations = {};

/**
 * Function to handle the missing translations.
 * It simply replaces the '[DOT]' with '.' in the key and returns that
 * It is needed because the i18n module uses the dot symbol as a property accessor
 * @param {string} key
 * @param replacements
 */
// eslint-disable-next-line no-unused-vars
var HandleMissingTranslation = function HandleMissingTranslation(key, replacements) {
  return key.replace(/\[DOT\]/g, '.');
};
_reactReduxI18n.I18n.setHandleMissingTranslation(HandleMissingTranslation);

/**
 * Function to merge the local (module related) translations into the global dictionary
 *  - call it with a translation object eg. { en: { greeting: 'Hi!' }, de: { greeting: 'Hallo!' } }
 *  - useful to call it from within a Translation.js file, doing it this way one need only to import it
 * @param {Object} translationsObject
 */
var mergeTranslations = exports.mergeTranslations = function mergeTranslations(translationsObject) {
  if (!store) {
    throw new Error('Store must be set up first!');
  }
  var translations = (0, _merge["default"])(store.getState().i18n.translations || {}, translationsObject);
  store.dispatch((0, _reactReduxI18n.loadTranslations)(translations));
};

/**
 * Function to change the locale
 * @param {string} locale
 */
var changeLocale = exports.changeLocale = function changeLocale(locale) {
  if (!store) {
    throw new Error('Store must be set up first!');
  }
  store.dispatch((0, _reactReduxI18n.setLocale)(locale.replace('_', '-')));
};

/**
 * Function to return the current locale
 * @return {string} The current locale
 */
var getLocale = exports.getLocale = function getLocale() {
  if (!store) {
    throw new Error('Store must be set up first!');
  }
  return store.getState().i18n.locale;
};

/**
 * Translates the given text
 * @param {string} value - The text to translate
 * @param {Object} props - The props passed to the Translate Component. Can contain (escapeDot: true)
 * to search with '[DOT]' instead of '.' (which is used as a property accessor)
 * @return {*}
 * @constructor
 */
var T = exports.T = function T(value) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // eslint-disable-next-line react/prop-types
  var escapeDot = props.escapeDot,
    otherProps = _objectWithoutProperties(props, _excluded);
  if (value === undefined) {
    return value;
  } else if (escapeDot && (0, _isString["default"])(value)) {
    value = value.replace(/\./g, '[DOT]');
  }
  if ((0, _isObject["default"])(otherProps)) {
    for (var p in otherProps) {
      // if the replacement is a jsx element, just render it in place
      if ( /*#__PURE__*/_react["default"].isValidElement(otherProps[p])) {
        otherProps[p] = _server["default"].renderToStaticMarkup(otherProps[p]);
      }
    }
  }
  return /*#__PURE__*/_react["default"].createElement(_reactReduxI18n.Translate, _extends({
    value: '' + value,
    dangerousHTML: true
  }, otherProps));
};

/**
 * Localize the given value
 * @param {*} value - The value to localize
 * @param {Object} props - The props passed to the Localize Component. Can contain (escapeDot: true)
 * to search with '[DOT]' instead of '.' (which is used as a property accessor)
 * @return {*}
 * @constructor
 */
var L = exports.L = function L(value) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // eslint-disable-next-line react/prop-types
  var escapeDot = props.escapeDot,
    otherProps = _objectWithoutProperties(props, _excluded2);
  if (value === undefined) {
    return value;
  } else if (escapeDot && (0, _isString["default"])(value)) {
    value = value.replace(/\./g, '[DOT]');
  }
  return /*#__PURE__*/_react["default"].createElement(_reactReduxI18n.Localize, _extends({
    value: '' + value
  }, otherProps));
};
var Hyphenated = exports.Hyphenated = (0, _reactRedux.connect)(function (_ref) {
  var locale = _ref.i18n.locale;
  return {
    locale: locale
  };
})(function (_ref2) {
  var children = _ref2.children,
    locale = _ref2.locale;
  var hyphenations = (0, _configuration.getConf)('hyphenations');
  if (hyphenations[locale]) {
    return locale === 'en-GB' ? /*#__PURE__*/_react["default"].createElement(_reactHyphen["default"], null, children) : /*#__PURE__*/_react["default"].createElement(_reactHyphen["default"], {
      language: hyphenations[locale]
    }, children);
  }
  return children;
});

/**
 * Function to merge the local (module related) translations into the global dictionary
 *  - call it with a translation object eg. { en: { greeting: 'Hi!' }, de: { greeting: 'Hallo!' } }
 *  - useful to call it from within a Translation.js file, doing it this way one need only to import it
 * @param {Object} translationsObject
 */
function use(translationsObject) {
  if (store && store.dispatch) {
    // if store exists just call the merge function
    mergeTranslations(translationsObject);
  } else {
    // merge with pre-init translations
    (0, _merge["default"])(translations, translationsObject);
  }
}

/**
 * Checks if translation exists for the given key
 * @param {string} key - The key of the translation
 * @return {boolean}
 * @constructor
 */
var translationExists = exports.translationExists = function translationExists(key) {
  // Copied from react-i18nify, I18n._translate
  var locale = _reactReduxI18n.I18n._translations[_reactReduxI18n.I18n._locale] ? _reactReduxI18n.I18n._locale : _reactReduxI18n.I18n._locale.split('-')[0];
  var translations = _reactReduxI18n.I18n._translations[locale];
  if (!translations) {
    return false;
  }
  var translation = (0, _get["default"])(translations, key, null);
  return translation !== null;
};
var _default = exports["default"] = {
  use: use,
  changeLocale: changeLocale,
  getLocale: getLocale,
  T: T,
  L: L
};
function translateComponent(ComponentToTranslate, mapStateToProps, mapDispatchToProps) {
  var TranslatedComponent = /*#__PURE__*/function (_Component) {
    _inherits(TranslatedComponent, _Component);
    var _super = _createSuper(TranslatedComponent);
    function TranslatedComponent(props) {
      var _this;
      _classCallCheck(this, TranslatedComponent);
      _this = _super.call(this, props);
      // decorate the component, so it can use directly the t() function
      _defineProperty(_assertThisInitialized(_this), "setRef", function (ref) {
        _this.wrappedInstance = ref;
      });
      ComponentToTranslate.prototype.t = _this.t;
      return _this;
    }
    _createClass(TranslatedComponent, [{
      key: "t",
      value: function t() {
        if (store) {
          return _reactReduxI18n.I18n.t.apply(_reactReduxI18n.I18n, arguments);
        } else {
          throw new Error('Store must be set up first!');
        }
      }
    }, {
      key: "render",
      value: function render() {
        // if not child of Component return without ref
        if (!ComponentToTranslate.prototype.render) {
          return /*#__PURE__*/_react["default"].createElement(ComponentToTranslate, _objectSpread(_objectSpread({}, this.props), {}, {
            t: this.t
          }));
        }
        return /*#__PURE__*/_react["default"].createElement(ComponentToTranslate, _extends({
          ref: this.setRef
        }, _objectSpread(_objectSpread({}, this.props), {}, {
          t: this.t
        })));
      }
    }]);
    return TranslatedComponent;
  }(_react.Component); // mapping state.locale to the locale prop, so the component will update when locale changes
  function mapMergedProps(state) {
    return _objectSpread(_objectSpread({}, mapStateToProps instanceof Function && mapStateToProps(state)), {}, {
      locale: state.i18n.locale
    });
  }
  return (0, _reactRedux.connect)(mapMergedProps, mapDispatchToProps)(TranslatedComponent);
}
var t = exports.t = _reactReduxI18n.I18n.t.bind(_reactReduxI18n.I18n);
function useTranslationWithoutStore() {
  _reactReduxI18n.I18n.setTranslationsGetter(function () {
    return translations;
  });
  _reactReduxI18n.I18n.setLocaleGetter(function () {
    return 'en-GB';
  });
}
// eslint-disable-next-line react-hooks/rules-of-hooks
useTranslationWithoutStore();
window.changeLocale = changeLocale;